import loadable from '@utils/loadable';

import { useSelector } from 'react-redux';
import withComponentName from '../../../decorators/withComponentName';
import withMetatag from '../../../decorators/metadataDecorators/metatagsTitleDecorator';

import Styles from './styles.module.scss';

const AcademiaPlansSection = loadable(() => import('./AcademiaComponents/AcademiaPlansSection'));
const AcademicNeedsSection = loadable(() => import('./AcademiaComponents/AcademicNeedsSection'));
const AcademicDepartmentsSection = loadable(() => import('./AcademiaComponents/AcademicDepartmentsSection'));
const AcademiaGreetingSection = loadable(() => import('./AcademiaComponents/AcademiaGreetingSection'));
const StructuredDataSection = loadable(() => import('./AcademiaComponents/StructuredDataSection'));
const GlobalCoverageSection = loadable(() => import('./AcademiaComponents/GlobalCoverageSection'));
const ContactUsFormSection = loadable(() => import('./AcademiaComponents/ContactUsFormSection'));

const AcademiaLanding = () => {
  const { searchBarActive } = useSelector((state) => state.searchReducers);

  return (
    <div className={Styles['academia-wrapper']}>
      { searchBarActive && <div className={Styles.overlay} /> }
      <AcademiaGreetingSection />
      <AcademiaPlansSection />
      <AcademicNeedsSection />
      <AcademicDepartmentsSection />
      <StructuredDataSection />
      <GlobalCoverageSection />
      <ContactUsFormSection />
    </div>
  );
};

export default withComponentName(withMetatag(AcademiaLanding, 'segments/academia'));
